import React, {useState} from "react";
import img from "./assets/img.png";
import GetYouProjects from "../../../GlobalComponents/GetYouProjects/GetYouProjects";
const Completed = () => {
  const Card = () => (
    <div className="flex flex-col gap-[20px] md:flex-row items-center justify-between px-[32px] pt-[35px] pb-[34px] bg-main-black rounded-[10px]">
      <div className="flex items-center gap-[19px]">
        <img className="w-[75px]" src={img} alt="" />
        <div>
          <h2 className="font-black text-res-xs">Token Name</h2>
          <h4 className="font-semibold text-res-xxs text-[#999898]">
            PRICE = 0.03 BNB per Token
          </h4>
          <p className="text-[12px] font-semibold leading-[12px] text-[#F2F2F2]">
            Chain: Binance Smart Chain
          </p>
        </div>
      </div>
      <div>
        <h4 className="text-res-xs font-semibold mb-[5px]">Raised Amount</h4>
        <p className="text-res-xs font-extrabold mb-[8px] ">
          <span className="text-bright-green ">18,000 </span> / 50,000 BNB
        </p>
        <div className=" h-[9px] relative w-[220px] rounded-full overflow-hidden">
          <div className="w-full h-full bg-light-black absolute"></div>
          <div
            id="bar"
            className="h-full bg-bright-green relative "
            style={{ width: `${(18000 / 50000) * 100}%` }}
          ></div>
        </div>
      </div>
    </div>
  );
  return (
    <div className="container mt-[116px]">
      <div className="container-1240">
        <div>
          <h2 className="text-center text-res-lg font-semibold mb-[40px]">
            Completed
          </h2>
        </div>
        <div className="grid gap-[14px]">
          <Card></Card>
          <Card></Card>
          <Card></Card>
        </div>
        <div className="flex justify-center mt-[40px]">
          <button className="rounded-[20px] w-[173px] h-[40px] text-light-black font-bold text bg-main-green">
            {" "}
            View More
          </button>
        </div>

        <div className="mt-[116px]">
          <GetYouProjects></GetYouProjects>
        </div>
      </div>
    </div>
  );
};

export default Completed;
